module.exports = __webpack_public_path__ + "img/cancel.b861eba4.svg";